function RangeIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={(size * 32) / 33}
        viewBox='0 0 33 32'
      >
        <path
          d='M3.5 16H30.5'
          stroke='currentColor'
          fill='none'
          strokeWidth='2'
          strokeLinecap='round'
        />
        <circle cx='23.5' cy='16' r='3' fill='currentColor' />
        <circle cx='9.5' cy='16' r='3' fill='currentColor' />
      </svg>
    </span>
  );
}

export default RangeIcon;
